import { useQuery } from "react-query";
import { uncoveryApi } from "..";

const fetchDefaultEntity = async () => {
  const query = `/entities?page=1&pageSize=1&searchTerm=&sortBy=createdAt&orderBy=desc`;
  const { data } = await uncoveryApi.get(query);
  if (data.data.length) {
    return data.data[0];
  }
  return null;
};

export default function useFetchDefaultEntity(enabled = true) {
  return useQuery(["defaultEntity"], () => fetchDefaultEntity(), {
    refetchOnWindowFocus: false,
    enabled,
    retry: false,
  });
}
